export const FETCH_STOCK_POOL = 'FETCH_STOCK_POOL';
export const FETCH_STOCK_PRICE = 'FETCH_STOCK_PRICE';
export const FETCH_ANALYSIS_LIST = 'FETCH_ANALYSIS_LIST';
export const FETCH_TRACKING_STOCK = 'FETCH_TRACKING_STOCK';
export const TRACK_STOCK = 'TRACK_STOCK';
export const ADD_FAVORITE_GROUP = "ADD_FAVORITE_GROUP";
export const FETCH_PANELDATA = 'FETCH_PANELDATA';
export const REMOTE_DELETE_FAVORITE_GROUP = 'REMOTE_DELETE_FAVORITE_GROUP';
export const REMOTE_CLEAR_FAVORITE_GROUP = 'REMOTE_CLEAR_FAVORITE_GROUP';
export const RENAME_FAVORITE_GROUP = 'RENAME_FAVORITE_GROUP';